import firebase, { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

const store = {
    state: {
        proveedores: {},
    },
    getters: {
        proveedores: state => {
            return state.proveedores
        },
        indiceProveedores: state => {

            const lista = []
      
            for(const i in state.proveedores){
      
              const proveedor = state.proveedores[i]
              proveedor.id = i
      
              lista.push(proveedor)
      
            }
      
            return lista;
      
          }
    },
    mutations: {
        ASIGNA_PROVEEDORES(state, proveedores) {
            state.proveedores = proveedores
        },
    },
    actions: {

        guardarProveedor({ getters }, proveedor) {
            console.log("Ejecuta guardar proveedor")
            proveedor.fecha_alta = new Date()

            return new Promise((resolve, reject) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.PROVEEDORES).add(proveedor).then(doc => {
                    resolve(doc)
                }).catch(e => {
                    reject(e)
                })

            })

        },
        actualizarProveedor({ getters }, props) {

            const {proveedor, id_proveedor} = props

            if(proveedor.fecha_alta) delete proveedor.fecha_alta

            return new Promise((resolve, reject) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.PROVEEDORES).doc(id_proveedor)
                .update(proveedor).then(doc => {
                    resolve(doc)
                }).catch(e => {
                    reject(e)
                })

            })

        },
        obtenerProveedor({getters},id_proveedor){

            return new Promise((resolve,reject) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                .collection(FS_COLLECTIONS.PROVEEDORES).doc(id_proveedor).get().then(doc => {

                    if(!doc.exists) reject("El documento no existe")
                    resolve(doc.data())

                }).catch(e => {
                    reject(e)
                })

            })

        },
        obtenerProveedores({ getters, commit }) {

            return new Promise((resolve) => {

                db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
                    .collection(FS_COLLECTIONS.INDICES).doc(FS_COLLECTIONS.PROVEEDORES)
                    .onSnapshot(doc => {

                        commit('ASIGNA_PROVEEDORES', doc.data() || {})
                        resolve()

                    }
                )

            })

        },

    }
}

export default store



// WEBPACK FOOTER //
// ./src/store/proveedores/index.js